import { render } from "./CarouselPage.vue?vue&type=template&id=46b4d7ec&scoped=true"
import script from "./CarouselPage.vue?vue&type=script&lang=js"
export * from "./CarouselPage.vue?vue&type=script&lang=js"

import "./CarouselPage.vue?vue&type=style&index=0&id=46b4d7ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b4d7ec"]])

export default __exports__